module.exports = __webpack_public_path__ + "img/0-77.298255d5.jpg";